import React from 'react';

export const GardenLogo = ({ className = "w-10 h-10", variant = "default" }) => (
  <div className={`relative ${className} flex items-center justify-center`}>
    {/* Stylized Leaf HUD Mark */}
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <path d="M50 15C50 15 20 40 20 65C20 85 35 90 50 90C65 90 80 85 80 65C80 40 50 15 50 15Z" 
            className={variant === 'light' ? 'fill-clay' : 'fill-lime'} />
      <path d="M50 15V90M50 40L25 55M50 60L75 75M50 30L70 45M50 70L30 85" 
            className={variant === 'light' ? 'stroke-garden-darkest' : 'stroke-garden-darkest'} 
            strokeWidth="3" strokeLinecap="round" />
      {/* Cockpit HUD lines */}
      <circle cx="50" cy="65" r="30" stroke={variant === 'light' ? '#0B1A10' : '#A3E635'} strokeWidth="1" strokeDasharray="4 4" opacity="0.5" />
      <path d="M10 65H25M75 65H90M50 5V20M50 80V95" stroke={variant === 'light' ? '#0B1A10' : '#A3E635'} strokeWidth="2" strokeLinecap="round" />
    </svg>
  </div>
);

export const EmptyStateIcon = ({ className = "w-20 h-20" }) => (
  <div className={className}>
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" stroke="#1E4226" strokeWidth="2" strokeDasharray="6 6" />
      <path d="M40 45L50 55L60 45" stroke="#2D5A36" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M30 65C30 65 40 70 50 70C60 70 70 65 70 65" stroke="#2D5A36" strokeWidth="2" strokeLinecap="round" />
    </svg>
  </div>
);

export const SectionBadge = ({ label }) => (
  <div className="inline-flex items-center gap-2 bg-garden-base/30 border border-lime/20 px-2 py-0.5 rounded text-[10px] font-mono text-lime uppercase tracking-widest">
    <span className="w-1 h-1 bg-lime rounded-full animate-pulse"></span>
    {label}
  </div>
);